import { render, staticRenderFns } from "./ClassRoomEdit.vue?vue&type=template&id=4088d46a&scoped=true&"
import script from "./ClassRoomEdit.vue?vue&type=script&lang=js&"
export * from "./ClassRoomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088d46a",
  null
  
)

export default component.exports